/**
 * セット企画設定画面　プロモーション商品登録VOクラス
 */
export class KYMW1312RegistSetPlanPromotionGoodsModel {
  /** プロモーションＮＯ */
  public promotionNo: string = <string>'';

  /** プロモーション名称 */
  public promotionName: string = <string>'';

  /** プロモーション区分 */
  public promotionDiv: string = <string>'';

  /** 受注コード */
  public orderCode: string = <string>'';

  /** 媒体区分 */
  public mediumType: string = <string>'';

  /** 登録登録リスト */
  public registGoodsList: Array<any> = new Array<any>();
}
